import { NS_SVG } from "../constants";

export function SVG_DrawCircle(cx, cy, radius, strokeColor, strokeWidth, svgElement) {
  //cx = SVG_ShiftX(cx, svgElement);
  //cy = SVG_ShiftY(cy, svgElement);

  var circleObj = document.createElementNS(NS_SVG, "circle");
  circleObj.setAttribute("cx", cx);
  circleObj.setAttribute("cy", cy);
  circleObj.setAttribute("r", radius);
  circleObj.setAttribute("fill", "none");
  circleObj.setAttribute("stroke", strokeColor);
  circleObj.setAttribute("stroke-width", strokeWidth);

  svgElement.appendChild(circleObj);
  return circleObj;
}
